/* eslint-disable import/no-extraneous-dependencies */
import { Typography } from '@alfalab/core-components/typography';
import { LockClosedMIcon } from '@alfalab/icons-glyph';
import { createCn } from 'bem-react-classname';

const cn = createCn('form');

export const SecurityGuarantee: React.FC = () => (
    <div className={cn('content')}>
        <LockClosedMIcon className={cn('icon')} />
        <Typography.Text view='secondary-large' tag='div'>
            Мы гарантируем безопасность и сохранность ваших данных
        </Typography.Text>
    </div>
);
